import Eyebrow from "../shared/Eyebrow";
import TypedHeading from "../shared/TypedHeading";
import Reveal from "../shared/Reveal";
import useCodeTyper from "../../hooks/useCodeTyper";
import useI18n from "../../i18n/useI18n";
import { architectureCode } from "../../data/techStack";

const HomeAboutComponent = () => {
  const { t } = useI18n();
  const preRef = useCodeTyper(architectureCode);
  const whys = t("about.whys");

  return (
    <section id="about" className="about section">
      <div className="about__inner">
        <div className="about__col">
          <Reveal><Eyebrow>{t("about.eyebrow")}</Eyebrow></Reveal>
          <TypedHeading text={t("about.title")} className="about__title" />
          <Reveal as="p" className="about__p">{t("about.p1")}</Reveal>
          <Reveal as="p" className="about__p">{t("about.p2")}</Reveal>

          <div className="about__whys">
            {Array.isArray(whys) &&
              whys.map((why, i) => (
                <Reveal key={i} className="about__why" delayMs={i * 60}>
                  <span className="about__why-mark">✦</span>
                  <div>
                    <div className="about__why-title">{why.title}</div>
                    <div className="about__why-desc">{why.desc}</div>
                  </div>
                </Reveal>
              ))}
          </div>
        </div>

        <Reveal className="about__panel">
          <div className="code-panel">
            <div className="code-panel__bar">
              <span className="code-panel__dot code-panel__dot--r" />
              <span className="code-panel__dot code-panel__dot--y" />
              <span className="code-panel__dot code-panel__dot--g" />
              <span dir="ltr" className="code-panel__file">{t("about.panelFile")}</span>
            </div>
            <pre ref={preRef} dir="ltr" className="code-panel__code" aria-hidden="true" />
          </div>
          <div className="about__kpis">
            <div className="about__kpi">
              <div className="about__kpi-label">{t("about.firstVersionLabel")}</div>
              <div className="about__kpi-value">{t("about.firstVersion")}</div>
            </div>
            <div className="about__kpi">
              <div className="about__kpi-label">{t("about.afterLaunchLabel")}</div>
              <div className="about__kpi-value">{t("about.afterLaunch")}</div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default HomeAboutComponent;
